"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = require("../..");
var _SourcePropType = _interopRequireDefault(require("../SourcePropType"));
var _broadcastSourceHelper = require("../../utils/broadcastSourceHelper");
var _globalTooltipDelay = require("../../utils/globalTooltipDelay");
var _SourceItemBodyBottomSection = require("./SourceItemBodyBottomSection.styled");
var _SourceMediaControl = _interopRequireDefault(require("./SourceMediaControl"));
var _SourcePdfAssignControl = _interopRequireDefault(require("./SourcePdfAssignControl"));
var _TooltipMessages = require("./TooltipMessages");
var _useTranslate2 = require("../../locales/useTranslate");
var SourceItemBodyBottomSection = function SourceItemBodyBottomSection(_ref) {
  var source = _ref.source,
    onSourceStaged = _ref.onSourceStaged,
    enableFeature = _ref.enableFeature,
    isStaged = _ref.isStaged,
    onVolumeChanged = _ref.onVolumeChanged,
    isAudioSource = _ref.isAudioSource,
    live = _ref.live,
    hovered = _ref.hovered,
    user = _ref.user,
    viewPermissions = _ref.viewPermissions,
    onPdfAssignClicked = _ref.onPdfAssignClicked;
  var isDirectorLite = (0, _.useStudioLiteContext)();
  var _useTranslate = (0, _useTranslate2.useTranslate)(),
    translate = _useTranslate.translate;
  var type = source.type,
    _id = source._id,
    value = source.value;
  var isAudioOrVideoSource = (0, _broadcastSourceHelper.isAudioVideoSource)(source);
  var networkHealthIndicatorsEnabled = (0, _.shouldHaveFeature)('studio.networkHealthIndicators');
  var showSignalStrength = networkHealthIndicatorsEnabled && source.type === _.CAMERA_PRESENTER && value !== _broadcastSourceHelper.UNASSIGNED;
  var targetElementId = "select-source-".concat(_id);
  var mode = isDirectorLite ? 'dark' : 'light';
  var isPdfControl = hovered && source.type === _.PDF_FILE;
  return _react["default"].createElement(_SourceItemBodyBottomSection.SourceItemBodyBottomWrapper, null, hovered && _react["default"].createElement(_SourceItemBodyBottomSection.StyledCheckBoxWrapper, {
    onClick: function onClick(event) {
      event.stopPropagation();
      onSourceStaged();
    }
  }, _react["default"].createElement("div", {
    id: targetElementId
  }, _react["default"].createElement(_SourceItemBodyBottomSection.StyledCheckBox, {
    id: _id,
    checked: isStaged,
    dataTestId: "stage-source",
    enableFeature: enableFeature,
    ddActionName: "".concat(source.type, " ").concat(isStaged ? 'Unchecked' : 'Checked', " - ").concat(_id),
    isV2: true
  }), _react["default"].createElement(_.ToolTip, {
    targetElement: targetElementId,
    placement: 'bottom',
    message: (0, _TooltipMessages.getSourceTooltipMessage)(source.type, isStaged, translate),
    mode: mode,
    delay: _globalTooltipDelay.TOOL_TIP_DELAY
  }))), showSignalStrength ? _react["default"].createElement(_.SignalStrengthV2, {
    attendeeId: value,
    mode: mode
  }) : isPdfControl ? _react["default"].createElement(_SourceItemBodyBottomSection.StyledItemWrapper, null, _react["default"].createElement(_SourcePdfAssignControl["default"], {
    sourceId: source._id,
    type: source.type,
    value: source.value,
    onPdfAssignClicked: onPdfAssignClicked
  })) : isAudioOrVideoSource && _react["default"].createElement(_SourceItemBodyBottomSection.StyledItemWrapper, null, _react["default"].createElement(_SourceMediaControl["default"], {
    sourceId: _id,
    source: source,
    type: type,
    onVolumeChanged: onVolumeChanged,
    isAudioSource: isAudioSource,
    live: live,
    user: user,
    viewPermissions: viewPermissions
  })));
};
SourceItemBodyBottomSection.propTypes = {
  source: _SourcePropType["default"],
  onSourceStaged: _propTypes["default"].func,
  enableFeature: _propTypes["default"].bool,
  isStaged: _propTypes["default"].bool,
  onVolumeChanged: _propTypes["default"].func,
  isAudioSource: _propTypes["default"].bool,
  live: _propTypes["default"].bool,
  hovered: _propTypes["default"].bool,
  user: _propTypes["default"].object,
  viewPermissions: _propTypes["default"].object,
  onPdfAssignClicked: _propTypes["default"].func
};
var _default = exports["default"] = SourceItemBodyBottomSection;